import { useQuery } from '@tanstack/react-query'
import { useApiClientAmbassador } from '~/@api/client/useApiClientAmbassador'

export const ambassadorDetailQueryKey = (ambassadorId: string) => [
  'ambassador-detail',
  ambassadorId,
]

/** Fetches the full detail (incl. client list) for a single ambassador. */
export function useAmbassadorDetail(ambassadorId: string) {
  const api = useApiClientAmbassador()

  return useQuery({
    queryKey: ambassadorDetailQueryKey(ambassadorId),
    enabled: ambassadorId.length > 0,
    queryFn: async () => {
      const resp = await api.user.ambassadorControllerGetAmbassadorDetail(
        ambassadorId,
        { secure: true }
      )
      return resp.data.data
    },
  })
}
